import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '../components/Dashboard.vue';
import DashboardShipments from '../components/DashboardShipments.vue';
import UserLayout from '../views/UserLayout.vue';
import PublicLayout from '../views/PublicLayout.vue';
import Landing from '../views/Landing2.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Landing,
    meta: {
      title: 'SoonForward',
    },
  },
  {
    path: '/',
    component: UserLayout,
    meta: {
      title: 'SoonForward Web',
    },
    children: [
      {
        path: '/dash',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        children: [
          { path: '/', component: Dashboard },
          { path: '/dash/delivering', component: DashboardShipments },
          { path: '/dash/toload', component: DashboardShipments },
          { path: '/dash/pickups', component: DashboardShipments },
          { path: '/dash/unpaid', component: DashboardShipments },
          { path: '/dash/delayed', component: DashboardShipments },
        ],
      },
      {
        path: '/manifest',
        name: 'Manifest',
        // route level code-splitting
        // this generates a separate chunk (manifest.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "manifest" */ '../views/Manifest.vue'),
      },
      {
        path: '/manifest-proto/:id?',
        name: 'ManifestProto',
        component: () => import('../views/Manifest2.vue'),
      },
      {
        path: '/manifest-find',
        name: 'ManifestFind',
        component: () => import('../views/ManifestFind.vue'),
      },
      {
        path: '/shipment-find',
        name: 'ShipmentFind',
        component: () => import('../views/ShipmentFind.vue'),
      },
      {
        path: '/settings',
        name: 'UserProfile',
        component: () => import('../views/Settings.vue'),
        children: [
          { path: '/', component: () => import('../views/NotFoundComponent.vue') },
          {
            path: '/settings/account', component: () => import('../components/Profile.vue'),
          },
          {
            path: '/settings/roles', component: () => import('../views/RolesSettings.vue'), meta: { authorize: ['Admin'] },
          },
        ],
      },
      // {
      //   path: '/settings',
      //   name: 'UserProfile',
      //   component: () => import('../views/UserProfile.vue'),
      //   children: [
      //     {
      //       path: '/settings/account',
      //       component: () => import('../views/UserProfile.vue'),
      //     },
      //     // {
      //     //   path: '/settings/roles',
      //     //   component: () => import('../views/RolesSettings.vue'),
      //     // },
      //   ],
      // },
      // {
      //   path: '/settings/roles',
      //   component: () => import('../views/RolesSettings.vue'),
      // },
      {
        path: '/shipment/:id?',
        name: 'Shipment',
        component: () => import('../views/Shipment.vue'),
      },
      {
        path: '/search',
        name: 'Search',
        component: () => import('../views/Search.vue'),
      },
    ],
  },
  {
    path: '/',
    component: PublicLayout,
    meta: {
      title: 'SoonForward',
    },
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
      },
    ],
  },
  {
    path: '*',
    name: 'Not Found',
    component: () => import(/* webpackChunkName: "not found" */ '../views/NotFoundComponent.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
  const previousNearestWithMeta = from.matched.slice().reverse().find((r) => r.meta);
  const { authorize } = to.meta;

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  const publicPages = ['/login', '/'];
  const authRequired = !publicPages.includes(to.path);

  const authorized = localStorage.getItem('access') || localStorage.getItem('refresh');
  if (authRequired && !authorized) {
    document.title = 'SoonForward';
    return next('/login');
  }

  if (authorize) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (authorize.length && !authorize.includes(user.roles)) {
      return next('/settings/account');
    }
  }

  return next();
});

export default router;
